import { RoutePath } from '@core/types/route';
import Icon from '@homepage/components/FooterIcon';
import { FooterGroup, FooterLink, IconType } from '@homepage/types/footer';
import { MARTIAL_ART_FOOTER, OFFERINGS_FOOTER, PEOPLE_FOOTER } from '@homepage/utils/footer';

import { COMPANY } from './company';

const KONTAKT: FooterLink[] = [
  {
    href: `tel:${COMPANY.phone}`,
    icon: <Icon type={IconType.Phone} />,
    text: COMPANY.phoneText,
  },
  {
    href: RoutePath.Kontakt,
    icon: <Icon type={IconType.Email} />,
    text: 'Kontakt aufnehmen',
  },
];

export const FOOTER: FooterGroup[] = [
  { links: KONTAKT, text: 'Kontakt' },
  { links: MARTIAL_ART_FOOTER, text: 'Kampfkunst' },
  { links: OFFERINGS_FOOTER, text: 'Angebote' },
  { links: PEOPLE_FOOTER, text: 'Lehrer' },
];
